var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.144 1.552c-.46-.958-1.827-.958-2.288 0L6.888 5.649l-4.534.594c-1.051.138-1.489 1.436-.706 2.174l3.313 3.124-.831 4.461c-.198 1.059.923 1.844 1.85 1.345L10 15.179l4.02 2.168c.927.5 2.048-.286 1.85-1.345l-.83-4.46 3.313-3.125c.782-.738.345-2.036-.707-2.174l-4.534-.594z"
})));
export default SvgStar20;